import { queryBuilder } from '@inpart-io/devtools-iap';
import { RECEIVE_DATA_OBJECTS, RETRIEVE_BY_QUERY, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { dealTypesManager, type IDealType, type ITemplateDealStage, templateDealStagesManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { SAVE_SEARCH_RESULT } from '@/store/base/search/actions';
import { TEMPLATE_DEAL_STAGE_MODULE } from '@/store/template-deal-stage-module';

export const CREATE_DEAL = 'createDeal';
export const RETRIEVE_ALL_DEAL_TYPES = 'retrieveAllDealTypes';
export const REORDER_STAGES = 'reorderStages';

export const actions: ActionTree<IDealType, unknown> = {
    async [CREATE_DEAL](context, { dealType, properties }: { dealType: IDealType; properties?: string }): Promise<number> {
        const result = await dealTypesManager.createDealType(dealType, { properties });

        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
        return result.dobjId;
    },
    async [RETRIEVE_ALL_DEAL_TYPES](context, { properties }: { properties: string }): Promise<number[]> {
        const query = queryBuilder.build(undefined, undefined, undefined, [
            {
                attribute: 'name',
                direction: 'ASC'
            }
        ]);
        const idList = await context.dispatch(RETRIEVE_BY_QUERY, {
            query,
            properties
        });
        await context.dispatch(SAVE_SEARCH_RESULT, { key: 'all', idList });
        return idList;
    },

    async [REORDER_STAGES](context, { dealTypeId, orderedList }: { dealTypeId: number; orderedList: number[] }): Promise<void> {
        await templateDealStagesManager.reorderStages(dealTypeId, orderedList);
        const dealType = { dobjId: dealTypeId, templateStages: orderedList };
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [dealType] });
        void context.dispatch(
            `${TEMPLATE_DEAL_STAGE_MODULE}/${STORE_DATA_OBJECTS}`,
            {
                dataObjectList: orderedList.map((dobjId, index) => {
                    return { dobjId, position: index };
                })
            },
            { root: true }
        );
    },

    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: IDealType[] }) {
        const dealTypes: IDealType[] = [];
        const templateStages: ITemplateDealStage[] = [];

        dataObjectList.forEach((dealType) => {
            let _dealType = Object.assign({}, dealType);

            // Extract templateStages objects if necessary
            if (dealType['@templateStages']?.length > 0) {
                const stageIdList: number[] = [];
                dealType['@templateStages'].forEach((stage) => {
                    templateStages.push(Object.assign({}, stage, { '@type': 'TemplateDealStage' }));
                    stageIdList.push(stage.dobjId);
                });
                _dealType = Object.assign({}, dealType, { templateStages: stageIdList, '@templateStages': undefined });
            }

            dealTypes.push(_dealType);
        });

        if (dealTypes.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: dealTypes });
        }
        if (templateStages.length > 0) {
            void context.dispatch(`${TEMPLATE_DEAL_STAGE_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: templateStages }, { root: true });
        }
    }
};
